export type ThemeId = 'classic' | 'banking' | 'midnight' | 'earth';

export interface ThemeOption {
  id: ThemeId;
  name: string;
  description: string;
  preview: { bg: string; primary: string; accent: string; sidebar: string };
}

export const THEMES: ThemeOption[] = [
  {
    id: 'classic',
    name: 'Classic',
    description: 'Teal & gold — the original AussiBooks look',
    preview: { bg: '#f5f9f7', primary: '#267a6b', accent: '#e6a817', sidebar: '#eef3f0' },
  },
  {
    id: 'banking',
    name: 'Banking Green',
    description: 'Rich deep green with gold highlights — luxurious & premium',
    preview: { bg: '#f2f6f3', primary: '#1b5e3b', accent: '#c4960a', sidebar: '#162e1e' },
  },
  {
    id: 'midnight',
    name: 'Midnight',
    description: 'Deep navy with cool blue accents — modern & professional',
    preview: { bg: '#f3f4f8', primary: '#3a4f8f', accent: '#4a8fd4', sidebar: '#1e2640' },
  },
  {
    id: 'earth',
    name: 'Warm Earth',
    description: 'Terracotta & amber — warm, grounded, natural',
    preview: { bg: '#f8f5f2', primary: '#8c4a22', accent: '#d4930a', sidebar: '#2e2018' },
  },
];

const THEME_KEY = 'aussibooks-theme';
const DARK_KEY = 'aussibooks-dark';

export function getStoredTheme(): ThemeId {
  return (localStorage.getItem(THEME_KEY) as ThemeId) || 'classic';
}

export function getStoredDarkMode(): boolean {
  return localStorage.getItem(DARK_KEY) === 'true';
}

export function applyTheme(id: ThemeId) {
  const root = document.documentElement;
  root.classList.remove('theme-classic', 'theme-banking', 'theme-midnight', 'theme-earth');
  root.classList.add(`theme-${id}`);
  localStorage.setItem(THEME_KEY, id);
}

export function applyDarkMode(enabled: boolean) {
  document.documentElement.classList.toggle('dark', enabled);
  localStorage.setItem(DARK_KEY, String(enabled));
}
